import { useMutation } from "urql";
import { graphql } from "../gql";

const rotateLeftDerivedImageMutation = graphql(`
  mutation RotateLeftDerivedImageMutation(
    $bucket: String!
    $id: ID!
    $key: String!
  ) {
    rotateLeftDerivedImage(bucket: $bucket, id: $id, key: $key) {
      ...SongFields
    }
  }
`);

const rotateRightDerivedImageMutation = graphql(`
  mutation RotateRightDerivedImageMutation(
    $bucket: String!
    $id: ID!
    $key: String!
  ) {
    rotateRightDerivedImage(bucket: $bucket, id: $id, key: $key) {
      ...SongFields
    }
  }
`);

export function useRotateDerivedImage() {
  const [rotateLeftResult, executeRotateLeft] = useMutation(
    rotateLeftDerivedImageMutation,
  );
  const [rotateRightResult, executeRotateRight] = useMutation(
    rotateRightDerivedImageMutation,
  );

  const rotateLeft = async (
    bucket: string,
    id: string,
    key: string,
  ): Promise<boolean> => {
    const result = await executeRotateLeft({
      bucket,
      id,
      key,
    });

    if (result.error) {
      console.error(
        "Fehler beim Rotieren des Bildes nach links:",
        result.error,
      );
      return false;
    }

    return result.data?.rotateLeftDerivedImage !== undefined;
  };

  const rotateRight = async (
    bucket: string,
    id: string,
    key: string,
  ): Promise<boolean> => {
    const result = await executeRotateRight({
      bucket,
      id,
      key,
    });

    if (result.error) {
      console.error(
        "Fehler beim Rotieren des Bildes nach rechts:",
        result.error,
      );
      return false;
    }

    return result.data?.rotateRightDerivedImage !== undefined;
  };

  return {
    rotateLeft,
    rotateRight,
    fetching: rotateLeftResult.fetching || rotateRightResult.fetching,
    error: rotateLeftResult.error || rotateRightResult.error,
  };
}
